<template>
  <div>
    <t-form label-width="100px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
      <t-form-item label="排列方向">
        <t-select v-model="attribute.radar.shape" size="small">
          <t-option label="圆形" value="circle" />
          <t-option label="多边形" value="polygon" />
        </t-select>
      </t-form-item>
      <e-collapse title="标题" :expand="false">
        <t-form-item label="文本">
          <t-input v-model="attribute.title.text" size="small" :maxcharacter="52" />
        </t-form-item>
        <t-form-item label="大小">
          <t-input-number v-model="attribute.title.textStyle.fontSize" size="small" :min="2" :max="100"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.textStyle.color"
            size="small" />
        </t-form-item>
        <t-form-item label="位置(X)">
          <e-chart-position v-model="attribute.title.left" :direction="'x'" />
        </t-form-item>
        <t-form-item label="位置(Y)">
          <e-chart-position v-model="attribute.title.top" :direction="'y'" />
        </t-form-item>
      </e-collapse>
      <e-collapse title="图例" :expand="false">
        <t-form-item label="显示">
          <t-switch v-model="attribute.legend.show" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="位置(X)">
          <e-chart-position v-model="attribute.legend.left" :direction="'x'" />
        </t-form-item>
        <t-form-item label="位置(Y)">
          <e-chart-position v-model="attribute.legend.top" :direction="'y'" />
        </t-form-item>
        <t-form-item label="布局方式">
          <t-radio-group v-model="attribute.legend.orient" size="small">
            <t-radio-button value="vertical">纵向</t-radio-button>
            <t-radio-button value="horizontal">横向</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="字体">
          <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="文字颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small"
            v-model="attribute.legend.textStyle.color" />
        </t-form-item>

      </e-collapse>
      <e-collapse title="label" :expand="false">
        <t-form-item label="label颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small"
            v-model="attribute.radar.axisName.color" />
        </t-form-item>
        <t-form-item label="label大小">
          <t-input-number v-model="attribute.radar.axisName.fontSize" :min="1" :max="100" :decimal-places="0" />
        </t-form-item>
      </e-collapse>

      <t-form-item label="配色透明度">
        <t-input-number v-model="attribute.areaStyleNormalOpacity" :min="0" :max="1" :step="0.1" />

      </t-form-item>
      <t-form-item label="配色">
        <e-color-group v-model="attribute.colors" enableAlpha :max="20" :gradient="false" />
      </t-form-item>
      <t-form-item label="分割区域">
        <t-switch v-model="attribute.radar.splitArea.show" :label="['显示', '隐藏']" size="small"></t-switch>
      </t-form-item>
      <t-form-item label="分割区域配色" v-show="attribute.radar.splitArea.show">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small"
          v-model="attribute.radar.splitArea.areaStyle.color[0]" enableAlpha />
        <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small"
          v-model="attribute.radar.splitArea.areaStyle.color[1]" enableAlpha />
      </t-form-item>
      <t-form-item label="网格线颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" @change="onRadarColorChange"
          v-model="attribute.radar.axisLine.lineStyle.color" enableAlpha />
      </t-form-item>
      <div style="color: #fff;text-indent: 1em">
        指示器设置：<t-button size="small" theme="primary" @click="addCol">新增列</t-button>
      </div>
      <t-table style="font-size: 12px;margin-top: 10px;" size="small" rowKey="id" :data="attribute.radar.indicator"
        :hover="true" :columns="columns" :bordered="true" @row-click="editRow" />
    </t-form>
    <t-dialog :header="modelAdd ? '添加' : '编辑'" v-model:visible="modelShow" :onConfirm="confirmRow"
      :footer="modelAdd" :draggable="true">
      <t-form>
        <t-form-item label="字段标识">
          <t-input v-model="currentRow.key" />
        </t-form-item>
        <t-form-item label="字段名">
          <t-input v-model="currentRow.name" />
        </t-form-item>
        <t-form-item label="最大值">
          <t-input-number :autoWidth="true" v-model="currentRow.max" :min="0" :decimal-places="0" />
        </t-form-item>
        <!-- v-show="currentRow.id" -->
        <t-form-item v-show="!modelAdd">
          <t-button theme="danger" @click="delCol">删除此列</t-button>
        </t-form-item>
      </t-form>
    </t-dialog>
  </div>
</template>

<script>
import EChartPosition from "@/components/designer/e-chart-position";
import EColorGroup from "@/components/designer/e-color-group";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-radar-option",
  components: { EColorGroup, EChartPosition, CptData },
  props: {
    attribute: Object,
    cptDataForm: Object
  },
  data() {
    return {
      columns: [
        { colKey: 'key', title: '字段标识' },
        { colKey: 'name', title: '字段名' },
        { colKey: 'max', title: '最大值' }
      ],
      currentRow: {},
      modelShow: false,
      modelAdd: false
    }
  },
  methods: {
    addCol() {
      this.currentRow = {};
      this.modelShow = true
      this.modelAdd = true
    },
    editRow(row) {
      this.currentRow = row.row;
      this.currentIndex = row.index;
      this.modelShow = true
      this.modelAdd = false
    },
    confirmRow() {
      if (!this.currentRow.key || !this.currentRow.name) {
        this.$message.error('请输入字段标识或字段名称');
        return;
      }
      console.log(this.attribute.radar.indicator)
      const id = new Date().getTime();
      // this.attribute.columns.push(Object.assign(this.currentRow, { id: id }));
      // { name: '力量', max: 6500, key:'li' },
      this.attribute.radar.indicator.push({
        key: this.currentRow.key,
        name: this.currentRow.name,
        max: this.currentRow.max,
        id
      })
      this.modelShow = false
    },
    delCol() {
      this.attribute.radar.indicator.splice(this.currentIndex, 1);
      this.modelShow = false
    },
    onRadarColorChange(color) {
      this.attribute.radar.axisLine.lineStyle.color = color
      this.attribute.radar.splitLine.lineStyle.color = color
    }
  }
}
</script>

<style scoped></style>
